import { ButtonPrimary } from "@nova/component-btn"
import { useWorkspacePermissions } from "features/data-management/workspace/useWorkspacePermissions"
import { useConfirmationModalContext } from "features/modals/WorkspaceConfirmationModalV2"
import { CreateFlightsModal } from "features/pilot-tracking/flights-page/CreateFlightsModal"
import { useCallback } from "react"
import { getGenericWorkspacePage, getGenericWorkspacePageHeader } from "../WorkspaceRoutes"
import * as Icons from "@nova/component-icons"
import { RecordsSection } from "features/pilot-tracking/dashboard/RecordsSection"
import { DroneHoursSection } from "features/pilot-tracking/dashboard/DroneHoursSection"
import { WorkspaceFlightTimeSection } from "features/pilot-tracking/dashboard/WorkspaceFlightTimeSection"
import { GroundedAircraftSection } from "features/pilot-tracking/dashboard/GroundedAircraftSection"
import { CurrencyStatusSection } from "features/pilot-tracking/dashboard/CurrencyStatusSection"

export const PilotTrackingDashboard = getGenericWorkspacePage({
    Header: getGenericWorkspacePageHeader({
        title: "Dashboard",

        rightItems: [
            () => {
                const confirmationModal = useConfirmationModalContext()
                const { isEditor } = useWorkspacePermissions()
                const handleAddFlightClick = useCallback(async () => {
                    await confirmationModal.confirm({
                        RenderComponent: ({ confirm, cancel }) => (
                            <CreateFlightsModal onCancel={cancel} onConfirm={confirm} />
                        ),
                    })
                }, [confirmationModal])

                if (!isEditor) return null

                return (
                    <ButtonPrimary
                        title="Flight"
                        LeftIcon={Icons.Plus}
                        onClick={handleAddFlightClick}
                    />
                )
            },
        ],
    }),
    Content: PilotTrackingDashboardContent,
})

function PilotTrackingDashboardContent() {
    return (
        <div className="flex flex-col gap-8 pb-6">
            <GroundedAircraftSection />
            <WorkspaceFlightTimeSection />
            <CurrencyStatusSection />
            <DroneHoursSection />
            <RecordsSection />
        </div>
    )
}
